<template>

  <section class="member-insurance" v-if="subscriptionType === 'student'">

  <div class="row ">
      <div class="col-xs-12">
          <h2 class="headline-lg medium">{{ d.insuranceHeader }}</h2>

          <div class="field-wrapper half">
              <label>{{ d.insuranceLabel }}*</label>
              <div class="list-inline">
                  <label class="radio">
                      <input type="radio" name="home-insurance" required="true" v-model="values.homeInsurance" :value="true" @change="emitter.emit('homeInsurance-change', true);">
                      <span class="checklabel">{{d.unionmemberyeslabel}}</span>
                      <span class="checkmark"></span>  
                  </label>

                  <label class="radio">
                      <input type="radio" name="home-insurance" required="true" v-model="values.homeInsurance" :value="false" @change="emitter.emit('homeInsurance-change', false);">
                      <span class="checklabel">{{d.unionmembernolabel}}</span>
                      <span class="checkmark"></span>
                  </label>
              </div>
              <div class="oncheck-message-yes">{{d.unionmemberyeshelpertips}}</div>
              <div class="oncheck-message-no">{{d.unionmembernohelpertips}}</div>
              <div class="input-errors" v-for="error of v$.values.homeInsurance.$errors" :key="error.$uid">
                  <div v-if="error.$validator == 'required' && !error.$response" class="error-msg">{{ d.errorStudentInsurance }}</div>
              </div>
              <HelperTip :rte="d.insuranceHelpTip"></HelperTip>
          </div>

      </div>

  </div>

  </section>

</template>

<script>
  import axios from 'axios'
  import useVuelidate from '@vuelidate/core'
  import { required } from '@vuelidate/validators'

  import DropDownWithSearch from '../FormComponents/DropDownWithSearch.vue'
  import HelperTip from '../FormComponents/HelperTip.vue'
  import { cultureMixin } from '../../util/cultureMixin.js';


export default {
  components: {
      DropDownWithSearch,
      HelperTip
  },
  mixins: [cultureMixin],
  setup () {
    // we use vuelidate for validation 
    // https://vuelidate-next.netlify.app/
    return { v$: useVuelidate({$lazy:true}) }
  },
  data: (instance) => {
    return {
      values: instance.store[instance.store.currentCulture].values.insuranceDetails,
      subscriptionType: instance.store.subscriptionType,
      d: instance.store[instance.store.currentCulture].dictionary,
      culture: instance.store.currentCulture,

      dictionaryData: [],
      isLoading: false,
      error: null
    }
  },
  
  methods: {
      async GetDictionaryData() {
          this.isLoading = true;
          this.error = null;

          try {
              const dataresponse = await axios.get(this.unionEndpoint);
              this.dictionaryData = dataresponse.data;

          } catch (error) {
              this.error = 'Der opstod en fejl under hentning af data:' + error.message;
              console.error(this.error);

          } finally {
              this.isLoading = false;

          }
      },
  },
  mounted() {
      //this.GetDictionaryData();

      this.emitter.on('culture-change', () => {
          this.values = this.store[this.store.currentCulture].values.insuranceDetails;
          this.d = this.store[this.store.currentCulture].dictionary;
          this.v$.$reset()
      });
  },
  validations() {
    if(this.subscriptionType === 'student'){
      return {
          values: {
            homeInsurance: { required }
          }
      };
    }
    else{
       return {
          values: {
            homeInsurance: {  }
          }
      };
    }
  }
}
</script>

<style scoped lang="postcss">
.disclaimer{
  font-family: var(--font-it-ex);
  letter-spacing: var(--letter-spacing);
  margin-bottom: 10px;
}

.headline-lg{
  text-align: left;
  margin-left: 0;
  margin-bottom: var(--grid-gutter);
}

.oncheck-message-yes, .oncheck-message-no {
display: none;
}

.list-inline:has(input[value="true"]:checked) ~  .oncheck-message-yes {
display: block;
font-family: var(--font-it-ex);
padding: 8px 0px 12px 0px;
}

.list-inline:has(input[value="false"]:checked) ~  .oncheck-message-no {
display: block;
font-family: var(--font-it-ex);
padding: 8px 0px 12px 0px;
}
</style>